import React, { useContext } from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { format, isWithinInterval } from 'date-fns';
import PropTypes from 'prop-types';
import { isToday } from './utils';
import { H3, H4 } from '../../../text';
import LayoutContext from '../../../../contexts/Layout';

const Header = props => {
    const { layout } = useContext(LayoutContext);
    const dateRange = props?.dateRange;
    const cellHeight = props?.cellHeight;
    const style = props?.style || {};
    const allDayEvents = props?.allDayEvents || [];
    const mode = props?.mode || 'week';
    const onNavigate = props?.onNavigate;
    const onEventPress = props?.onEventPress || (() => {});

    if (mode.equals('day')) {
        //small screens
        return (
            <>
                <View style={Styles.mobileContainer}>
                    <Text onPress={() => onNavigate && onNavigate('PREV')} style={Styles.mobileArrowIndicartor}>
                        {'<'}
                    </Text>
                    <Text style={{ fontFamily: 'GothamBook', fontSize: 28 }}>{format(dateRange[0], 'dd MMMM yyyy')}</Text>
                    <Text onPress={() => onNavigate && onNavigate('NEXT')} style={Styles.mobileArrowIndicartor}>
                        {'>'}
                    </Text>
                </View>
                <View>
                    {allDayEvents &&
                        allDayEvents.map(allDayEvent => {
                            if (isWithinInterval(dateRange[0], { start: allDayEvent.start, end: allDayEvent.end })) {
                                return (
                                    <Text
                                        key={allDayEvent.id}
                                        onPress={() => onEventPress && onEventPress(allDayEvent)}
                                        style={StyleSheet.flatten(Styles.eventTitle, { backgroundColor: allDayEvent.backgroundColor })}
                                    >
                                        {allDayEvent.title}
                                    </Text>
                                );
                            }
                        })}
                </View>
            </>
        );
    } else {
        //large screens
        return (
            <View style={StyleSheet.flatten(Styles.container, style)}>
                <View style={{ backgroundColor: '#fff', flex: 1, flexDirection: 'row' }}>
                    <View style={Styles.hourGuideColumn} />
                    {dateRange.map((date, index) => {
                        var _isToday = isToday(date);

                        return (
                            <View key={index} style={StyleSheet.flatten(Styles.wrapperItem, { backgroundColor: _isToday ? '#eaf6ff' : '#fff' })}>
                                <View style={{ alignItems: 'center', borderBottomColor: '#eee', borderBottomWidth: StyleSheet.hairlineWidth, width: '100%' }}>
                                    <H4 style={{ marginBottom: layout.styleGuide.spacer3 }} text={format(date, 'EEE')} />
                                    <H3 style={{ marginBottom: layout.styleGuide.spacer5 }} text={format(date, 'dd')} />
                                </View>
                                <View style={{ height: cellHeight }}>
                                    {allDayEvents.map(event => {
                                        if (isWithinInterval(date, { start: event.start, end: event.end })) {
                                            return (
                                                <Pressable key={event.id} onPress={() => onEventPress && onEventPress(event)} style={Styles.eventCell}>
                                                    <Text style={Styles.eventTitle}>{event.title}</Text>
                                                </Pressable>
                                            );
                                        }
                                    })}
                                </View>
                            </View>
                        );
                    })}
                </View>
            </View>
        );
    }
};

const Styles = StyleSheet.create({
    container: {
        borderColor: '#eee',
        borderWidth: StyleSheet.hairlineWidth,
        flexDirection: 'row'
    },
    eventCell: {
        backgroundColor: '#fa0000',
        borderBottomWidth: 0,
        borderRadius: 3,
        elevation: 2,
        end: 3,
        minWidth: '33%',
        overflow: 'hidden',
        padding: 4,
        position: 'absolute',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.2,
        shadowRadius: 1,
        start: 3,
        zIndex: 100
    },
    eventTitle: {
        color: '#fff',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14,
        marginHorizontal: 10,
        marginVertical: 5
    },
    hourGuideColumn: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderLeftColor: '#eee',
        borderLeftWidth: StyleSheet.hairlineWidth,
        borderRightColor: '#eee',
        borderRightWidth: StyleSheet.hairlineWidth,
        borderTopColor: '#eee',
        borderTopWidth: StyleSheet.hairlineWidth,
        justifyContent: 'center',
        width: 80
    },
    mobileArrowIndicartor: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '24pt' : 24
    },
    mobileContainer: {
        alignItems: 'center',
        backgroundColor: '#dde4e9',
        flexDirection: 'row',
        justifyContent: 'space-around',
        paddingVertical: 10
    },
    wrapperItem: {
        backgroundColor: '#fff',
        borderRightColor: '#eee',
        borderRightWidth: StyleSheet.hairlineWidth,
        borderLeftColor: '#eee',
        borderLeftWidth: StyleSheet.hairlineWidth,
        borderTopColor: '#eee',
        borderTopWidth: StyleSheet.hairlineWidth,
        flex: 1,
        paddingTop: 2
    }
});

Header.propTypes = {
    dateRange: PropTypes.arrayOf(Date).isRequired,
    cellHeight: PropTypes.number,
    style: PropTypes.object,
    allDayEvents: PropTypes.arrayOf(Object),
    mode: PropTypes.string,
    onNavigate: PropTypes.func,
    onEventPress: PropTypes.func
};

export default React.memo(Header);
